import { render } from "./PerformanceMarketingPaymentModal.vue?vue&type=template&id=3ce9a4fa"
import script from "./PerformanceMarketingPaymentModal.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__